import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from 'react-toastify';
import MainRoutes from "./Routes/MainRoutes";
import { Provider } from "react-redux"
import authReducer from "../src/store/reducers/auth/AuthReducer"
import dataReducer from "../src/store/reducers/data/dataReducer"
import { combineReducers, createStore, applyMiddleware } from "redux"
import ReduxThunk from 'redux-thunk';

function App() {

  const rootReducer = combineReducers({
    auth: authReducer,
    data: dataReducer




  })
  const Store = createStore(rootReducer, applyMiddleware(ReduxThunk))
  return (
    <Provider store={Store}>
      <MainRoutes />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </Provider>
  );
}

export default App;
